import router from '@/router/router';
import gtAlert from '@/components/service/alert/gt-alert.vue';
import gtFooter from '@/components/service/footer/gt-footer.vue';
import gtHeader from '@/components/service/header/gt-header.vue';
import gtProgress from '@/components/service/progress/gt-progress.vue';

export default {
    name: 'App',
    mixins: [],
    extends: {},
    components: { router, gtAlert, gtFooter, gtHeader, gtProgress },
    props: [],
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {

    },
    async mounted() {

		function checkIE(){
			return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
		}
		  
		// 解決IE a標籤連結失效問題
		if (checkIE()) {
			window.addEventListener('hashchange', () => {
				var currentPath = window.location.hash.slice(1);
			  	if (this.$route.path !== currentPath) {
			  	this.$router.push(currentPath)
				}
			}, false)
		}
	},
    updated() {},
    beforeDestroy() {},
    methods: {},
};


// WEBPACK FOOTER //
// ./src/App.js